exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "a[data-v-1ac6640a] {\n  position: relative;\n}\na svg[data-v-1ac6640a] {\n  position: absolute;\n  top: 45%;\n  left: 45%;\n}", ""]);

// exports
